<template>
  <modal class="modal overflow-y-scroll" name="add-to-playlist-modal" transition="pop-out" :width="modalWidth"
    :height="modalHeight" :scrollable="false" :adaptive="true" @before-open="beforeOpen">
    <div class="flex justify-end w-100">
      <a @click="closeModal" class="pa3 pointer iconColor">
        <font-awesome-icon icon="times"/>
      </a>
    </div>
    <div class=" flex flex-column items-center">
      <h1 class="tc mt0 f4 f3-ns textColor">{{ $t("playlists.addToPlaylist.title") }}</h1>
      <h2 v-if="track" class="tc mv0 f6 f5-ns ph5-ns ph3 mw-100 title textColor">{{track.title}}</h2>
      <div class="mv2">
        <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
      </div>
      <div class="w-100 flex flex-column items-center mv2">
        <span class="dark-red f7 mh2-ns mv2" v-if="!loading && !selectedPlaylistId">{{$t("error.playlistRequired")}}</span>
        <a @click="newPlaylist" class="w-90 flex b--black-20 br1 ba dim pointer mw5 mv1">
          <p class="tc textColor"><font-awesome-icon class="iconColor mh2" icon="plus"/>{{ $t("playlists.addToPlaylist.title") }}</p>
        </a>
        <div class="scrollable-container">
          <ul>
            <li v-for="playlist in myPlaylists" :track-by="playlist" :key="playlist.id" @click="selectPlaylist(playlist.id)"
              :class="{'bg-black-20': selectedPlaylistId && playlist.id === selectedPlaylistId}" class="mv1 w-90 mw5 textColor overflow">
              <playlist-select :playlist="playlist"/>
            </li>
          </ul>
        </div>
        <button class="w-50-ns w-90 block mv2 pointer btn textColor" @click.prevent="addTrackToPlaylist">{{$t("playlists.addToPlaylist.add")}}</button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import PlaylistSelect from '@/components/playlists/PlaylistSelect.vue'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
const MODAL_WIDTH = '30%'
const MODAL_HEIGHT = '60%'

export default {
  name: 'add-to-playlist',
  data () {
    return {
      selectedPlaylistId: null,
      track: null,
      modalWidth: MODAL_WIDTH,
      modalHeight: MODAL_HEIGHT,
      color: '#808080',
      size: '20px'
    }
  },
  components: {
    ClipLoader,
    PlaylistSelect,
    FontAwesomeIcon
  },
  created () {
    this.modalWidth = window.innerWidth < MODAL_WIDTH
      ? MODAL_WIDTH / 2
      : MODAL_WIDTH
  },
  methods: {
    ...mapActions('user', [
      'getMyPlaylists'
    ]),
    ...mapActions('playlist', [
      'addToPlaylist'
    ]),
    beforeOpen (event) {
      // !Aca
      this.getMyPlaylists().then(() => {
        this.selectedPlaylistId = this.myPlaylists[0].id
      }).catch((e) => {
        this.$toasted.show(this.userError, {type: 'error'})
      })
      this.track = event.params.track
    },
    closeModal () {
      this.$modal.hide('add-to-playlist-modal')
    },
    addTrackToPlaylist () {
      if (this.selectedPlaylistId) {
        this.addToPlaylist({trackId: this.track.id, playlistId: this.selectedPlaylistId}).then(() => {
          this.$toasted.show(this.$t('playlists.addToPlaylist.success'), {type: 'success'})
          this.closeModal()
        }).catch((e) => {
          if (this.playlistError.message === this.$t('playlists.addToPlaylist.trackAlreadyExist')) {
            this.closeModal()
            this.$toasted.show(this.playlistError.message, {theme: 'primary'})
          } else {
            this.$toasted.show(this.playlistError.message, {type: 'error'})
          }
        })
      } else {
        this.$toasted.show(this.$t('error.playlistRequired'), {type: 'error'})
      }
    },
    selectPlaylist (playlistId) {
      this.selectedPlaylistId = playlistId
    },
    newPlaylist () {
      this.closeModal()
      this.$modal.show('new-playlist-modal', {track: this.track})
    }
  },
  computed: {
    ...mapGetters('user', {
      myPlaylists: 'myPlaylists',
      userError: 'error'
    }),
    ...mapGetters('playlist', {
      playlistError: 'error'
    }),
    loading () {
      return this.$loading.isLoading('user getMyPlaylists') || this.$loading.isLoading('playlist addToPlaylist')
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/variables.scss';
.modal {
  z-index: 10000;
}
.title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.overflow {
  overflow: hidden;
}

.scrollable-container {
  max-height: 200px; /* Establece la altura máxima deseada */
  overflow-y: auto; /* Añade una barra de desplazamiento vertical si el contenido excede la altura máxima */
}
</style>




// WEBPACK FOOTER //
// src/components/modals/playlist/AddToPlaylist.vue